import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOffer = function (id) {
    return useApiCall(function (signal) { return api.offer.apiOfferDataIdGet(id, { signal: signal }); }, null, !!id, [id]);
};
